import { getCollections, getDate, cambiarTextos, getCollectionsComplete } from './functions';
let xlsx = require('json-as-xlsx');

export async function reporteUsuarios() {
	let array = [];
	const results = await getCollectionsComplete('usuarios');
	const preguntas = await getCollectionsComplete('preguntas');
	Object.keys(results).map((key) => {
		if (key !== '000000') {
			const dataUsuario = results[key];
			const dataPreguntas = preguntas[key];
			if (dataPreguntas) {
				if (dataPreguntas.puntos > 0) {
					// pregunta1
					let pregunta1 = `(1.- DE: ${dataPreguntas.pregunta1[0].from} > HACIA: ${dataPreguntas.pregunta1[0].to}) - `;
					pregunta1 += `(2.- DE: ${dataPreguntas.pregunta1[1].from} > HACIA: ${dataPreguntas.pregunta1[1].to}) - `;
					pregunta1 += `(3.- DE: ${dataPreguntas.pregunta1[2].from} > HACIA: ${dataPreguntas.pregunta1[2].to})`;
					// pregunta2
					let pregunta2 = `(1.- DE: ${dataPreguntas.pregunta2[0].from} > HACIA: ${dataPreguntas.pregunta2[0].to}) - `;
					pregunta2 += `(2.- DE: ${dataPreguntas.pregunta2[1].from} > HACIA: ${dataPreguntas.pregunta2[1].to}) - `;
					pregunta2 += `(3.- DE: ${dataPreguntas.pregunta2[2].from} > HACIA: ${dataPreguntas.pregunta2[2].to})`;
					// pregunta3
					let pregunta3 = `${dataPreguntas.pregunta3[0] ? `(${dataPreguntas.pregunta3[0]})` : ''}`;
					pregunta3 += `${dataPreguntas.pregunta3[1] ? `(${dataPreguntas.pregunta3[1]})` : ''}`;
					// pregunta4
					let pregunta4 = `(1.- DE: ${dataPreguntas.pregunta4[0].from} > HACIA: ${dataPreguntas.pregunta4[0].to}) - `;
					pregunta4 += `(2.- DE: ${dataPreguntas.pregunta4[1].from} > HACIA: ${dataPreguntas.pregunta4[1].to}) - `;
					pregunta4 += `(3.- DE: ${dataPreguntas.pregunta4[2].from} > HACIA: ${dataPreguntas.pregunta4[2].to})`;
					// pregunta5
					let pregunta5 = `${dataPreguntas.pregunta5[0] ? `(${dataPreguntas.pregunta5[0]})` : ''}`;
					pregunta5 += `${dataPreguntas.pregunta5[1] ? `(${dataPreguntas.pregunta5[1]})` : ''}`;
					pregunta5 += `${dataPreguntas.pregunta5[2] ? `(${dataPreguntas.pregunta5[2]})` : ''}`;
					// pregunta6
					let pregunta6 = `(1.- DE: ${dataPreguntas.pregunta6[0].from} > HACIA: ${dataPreguntas.pregunta6[0].to}) - `;
					pregunta6 += `(2.- DE: ${dataPreguntas.pregunta6[1].from} > HACIA: ${dataPreguntas.pregunta6[1].to}) - `;
					pregunta6 += `(3.- DE: ${dataPreguntas.pregunta6[2].from} > HACIA: ${dataPreguntas.pregunta6[2].to})`;
					// pregunta7
					let pregunta7 = `${dataPreguntas.pregunta7[0] ? `(${dataPreguntas.pregunta7[0]})` : ''}`;
					pregunta7 += `${dataPreguntas.pregunta7[1] ? `(${dataPreguntas.pregunta7[1]})` : ''}`;
					pregunta7 += `${dataPreguntas.pregunta7[2] ? `(${dataPreguntas.pregunta7[2]})` : ''}`;
					pregunta7 += `${dataPreguntas.pregunta7[3] ? `(${dataPreguntas.pregunta7[3]})` : ''}`;
					// pregunta8
					let pregunta8 = `(1.- DE: ${dataPreguntas.pregunta8[0].from} > HACIA: ${dataPreguntas.pregunta8[0].to}) - `;
					pregunta8 += `(2.- DE: ${dataPreguntas.pregunta8[1].from} > HACIA: ${dataPreguntas.pregunta8[1].to}) - `;
					pregunta8 += `(3.- DE: ${dataPreguntas.pregunta8[2].from} > HACIA: ${dataPreguntas.pregunta8[2].to})`;
					// pregunta9
					let pregunta9 = `${dataPreguntas.pregunta9[0] ? `(${dataPreguntas.pregunta9[0]})` : ''}`;
					// pregunta10
					let pregunta10 = `${dataPreguntas.pregunta10[0] ? `(${dataPreguntas.pregunta10[0]})` : ''}`;
					// pregunta11
					let pregunta11 = `${dataPreguntas.pregunta11[0] ? `(${dataPreguntas.pregunta11[0]})` : ''}`;
					pregunta11 += `${dataPreguntas.pregunta11[1] ? `(${dataPreguntas.pregunta11[1]})` : ''}`;
					pregunta11 += `${dataPreguntas.pregunta11[2] ? `(${dataPreguntas.pregunta11[2]})` : ''}`;
					// pregunta12
					let pregunta12 = `${dataPreguntas.pregunta12[0] ? `(${dataPreguntas.pregunta12[0]})` : ''}`;
					pregunta12 += `${dataPreguntas.pregunta12[1] ? `(${dataPreguntas.pregunta12[1]})` : ''}`;
					pregunta12 += `${dataPreguntas.pregunta12[2] ? `(${dataPreguntas.pregunta12[2]})` : ''}`;
					pregunta12 += `${dataPreguntas.pregunta12[3] ? `(${dataPreguntas.pregunta12[3]})` : ''}`;
					// pregunta13
					let pregunta13 = `${dataPreguntas.pregunta13[0] ? `(${dataPreguntas.pregunta13[0]})` : ''}`;
					pregunta13 += `${dataPreguntas.pregunta13[1] ? `(${dataPreguntas.pregunta13[1]})` : ''}`;
					pregunta13 += `${dataPreguntas.pregunta13[2] ? `(${dataPreguntas.pregunta13[2]})` : ''}`;
					// pregunta14
					let pregunta14 = `(${dataPreguntas.pregunta14[0]}`;
					// pregunta15
					let pregunta15 = `(${dataPreguntas.pregunta15[0]}`;

					array.push({
						mx: key,
						nombre: dataUsuario.nombre,
						pregunta1,
						pregunta2,
						pregunta3,
						pregunta4,
						pregunta5,
						pregunta6,
						pregunta7,
						pregunta8,
						pregunta9,
						pregunta10,
						pregunta11,
						pregunta12,
						pregunta13,
						pregunta14,
						pregunta15,
						puntos: dataPreguntas.puntos,
					});
				}
			}
		}
	});
	const fecha = cambiarTextos(getDate());

	let data = [
		{
			sheet: 'Usuarios',
			columns: [
				{ label: 'MX', value: 'mx' },
				{ label: 'Nombre', value: 'nombre' },
				{ label: 'Relaciona cada elemento del círculo dorado con su descripción correspondiente (al dar clic en cada elemento y la descripción que elijas, se pondrán del mismo color).', value: 'pregunta1' },
				{ label: 'Relaciona cada componente del feedback con su efecto principal desde una gestión remota:', value: 'pregunta2' },
				{ label: '¿Qué características son esenciales en un liderazgo conversacional? Selecciona todas las que apliquen:', value: 'pregunta3' },
				{ label: 'Relaciona el estilo de liderazgo con el nivel de madurez del colaborador:', value: 'pregunta3' },
				{ label: '¿Qué estrategias de Nudging son efectivas para mejorar el desempeño de un Asesor desde una gestión remota? Selecciona todas las que apliquen:', value: 'pregunta3' },
				{ label: 'Relaciona cada emoción con una respuesta adecuada en el contexto laboral:', value: 'pregunta3' },
				{ label: 'Ordena los pasos para resolver un conflicto en el equipo desde una gestión remota', value: 'pregunta3' },
				{ label: 'Relaciona las prácticas que reducen el estrés y mejoran la calidad de vida de los colaboradores desde el teletrabajo con su beneficio correspondiente:', value: 'pregunta3' },
				{ label: 'Un asesor con poca experiencia y baja confianza necesita preparar una presentación para un cliente importante. Como su líder, ¿qué estilo de liderazgo aplicarías para guiarlo?', value: 'pregunta3' },
				{ label: 'Uno de tus asesores está constantemente retrasado en el seguimiento de clientes, lo que afecta los cierres de ventas. ¿Qué enfoque utilizarías para darle feedback efectivo?', value: 'pregunta10' },
				{ label: 'Debes comunicar a tus asesores un cambio en las políticas de servicio que impactará en sus objetivos. A partir de lo aprendido, ordena las acciones que llevarías a cabo de acuerdo con el Círculo dorado', value: 'pregunta11' },
				{ label: 'Un cliente importante se queja de que uno de tus asesores no le proporcionó información clara sobre los rendimientos de su Afore. ¿Cuál sería el mejor proceso para manejar este conflicto con el Asesor? Ordena los pasos', value: 'pregunta12' },
				{ label: 'Tus asesores han mostrado baja iniciativa para realizar seguimientos proactivos con los clientes. ¿Qué estrategias de Nudging implementarías para impulsarlos?', value: 'pregunta13' },
				{
					label:
						'Adrían es un Asesor destacado en conocimientos técnicos, pero ha recibido retroalimentación sobre su falta de organización en la gestión de clientes. Constantemente pierde documentos importantes y no responde a tiempo los correos clave. Esto está afectando tanto su desempeño como la confianza de sus clientes. Como su líder, ¿qué acciones llevarías a cabo para ayudarlo a desarrollar su autodisciplina?',
					value: 'pregunta14',
				},
				{
					label: '1. Recolectar opiniones rápidas sobre cómo manejan ciertas situaciones con los clientes. 2. Diseñar una actividad final divertida para evaluar sus aprendizajes de manera competitiva. ¿Qué herramientas utilizarías para lograr ambos propósitos?',
					value: 'pregunta15',
				},
				{ label: 'Puntos', value: 'puntos' },
				// { label: 'Gerencia', value: 'gerencia' },
				// { label: 'Dirección', value: 'direccion' },
				// { label: 'Correo', value: 'correo' },
				// { label: 'MasterClass 1', value: 'masterClass1' },
				// { label: 'MasterClass 2', value: 'masterClass2' },
				// { label: 'Clase 1', value: 'clase1' },
				// { label: 'Clase 2', value: 'clase2' },
				// { label: 'Entregable', value: 'entregable' },
				// { label: 'Evaluación final', value: 'evaluacionFinal' },
				// { label: 'Asistencia 1', value: 'asistencia1' },
				// { label: 'Asistencia 2', value: 'asistencia2' },
				// { label: 'Descarga infografía 1', value: 'descarga1' },
				// { label: 'Descarga infografía 2', value: 'descarga2' },
			],
			content: array,
		},
	];
	console.log(array);

	let settings = {
		fileName: `Encuestas-${fecha}`, // Name of the resulting spreadsheet
		extraLength: 3, // A bigger number means that columns will be wider
		writeOptions: {}, // Style options from https://github.com/SheetJS/sheetjs#writing-options
	};

	xlsx(data, settings);
}
